// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "icon-3ZsAP";
var _4 = "button-2YKO7";
var _5 = "back-1URHi";
var _6 = "header-1JL7I";
export { _1 as "__esModule", _2 as "mobile", _3 as "icon", _4 as "button", _5 as "back", _6 as "header" }
export default { "__esModule": _1, "mobile": _2, "icon": _3, "button": _4, "back": _5, "header": _6 }
